import React, {Component} from 'react';
import {Breadcrumb, BreadcrumbItem} from "mdbreact";
import {Link} from "react-router-dom";

const pageTitle = "شرایط فروش";

export default class TermsOfSale extends Component {
    render() {
        return (
            <div >
                <div className="jumbotron text-center rtl">

                    <div className="container d-flex justify-content-start align-self-stretch  mt-5">
                        <div className="p-2 text-right rtl">
                            <h1 className="pag-title">{pageTitle}</h1>
                        </div>
                        <div className="ml-auto p-2">
                            <Breadcrumb className="">
                                <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                                {/*<BreadcrumbItem><a href="#">محصولات</a></BreadcrumbItem>*/}
                                <BreadcrumbItem active>{pageTitle}</BreadcrumbItem>
                            </Breadcrumb>

                        </div>
                    </div>
                </div>

                <div className="container rtl">
                    <div className="row">
                        <div className="col-sm-12" style={{minHeight:500}}>
                            <h3>{pageTitle}</h3>
                            <p className="text-justify">لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.</p>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/pages/TermsOfSale.js